import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { setRememberAction } from "../../actions/footerAction";
import { setPassRequestToOtherLandlordsAction } from "../../actions/footerAction";
import { setPrivacyPolicyAction } from "../../actions/footerAction";
import Language from '../../language/language.json';

const mapState = state => ({
    data : state.footer
});

const mapDispatchToProps = dispatch => ({
    setRemember:                        (payload) => dispatch(setRememberAction(payload)),
    setPassRequestToOtherLandlords:     (payload) => dispatch(setPassRequestToOtherLandlordsAction(payload)),
    setPrivacyPolicy:                   (payload) => dispatch(setPrivacyPolicyAction(payload)),
});

const Footer = (props) => {

    const remember                      = props.data.remember;
    const passRequestToOtherLandlords   = props.data.pass_request_to_other_landlords;
    const privacyPolicy                 = props.data.privacy_policy;

    const handleRememberChange = () => {
        const rememberSelected = !remember;
        props.setRemember(rememberSelected);
    };

    const handlePassRequestToOtherLandlordsChange = () => {
        const passRequestToOtherLandlordsSelected = !passRequestToOtherLandlords;
        props.setPassRequestToOtherLandlords(passRequestToOtherLandlordsSelected);
    };

    const handlePrivacyPolicyChange = () => {
        const privacyPolicySelected = !privacyPolicy;
        props.setPrivacyPolicy(privacyPolicySelected);
    };

    return (

        <>
            <div className='form_field_row'>
                <div className='check_box_fields'>
                    <div className="form-group">
                        <input type="checkbox" id="remember" defaultChecked={remember ? true : false }  onChange={handleRememberChange} />
                        <label htmlFor="remember">{Language[props.lang].remember}</label>
                    </div>
                    <div className="form-group">
                        <input type="checkbox" id="pass_request_to_other_landlords" defaultChecked={passRequestToOtherLandlords ? true : false } onChange={handlePassRequestToOtherLandlordsChange} />
                        <label htmlFor="pass_request_to_other_landlords">{Language[props.lang].passRequestToOtherLandlords}</label>
                    </div>
                    <div className="form-group">
                        <input type="checkbox" name="privacy_policy" id="privacy_policy" onChange={handlePrivacyPolicyChange} defaultChecked={privacyPolicy ? true : false } value="true" />
                        <label htmlFor="privacy_policy">{Language[props.lang].privacyPolicy}</label>
                    </div>
                </div>
            </div>
        </>
    );
};

Footer.propTypes = {
    prefix: PropTypes.string,
    lang: PropTypes.string,
}

export default connect(mapState, mapDispatchToProps)(memo(Footer));